// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8cf77e74","239":"2cd370fb","256":"a6b6ea8d","667":"308cc288","821":"5c87dd7a","859":"8d245a29","965":"ea0ac3a7","977":"eb3cec7c"}[chunkId] + ".chunk.js";
};